import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import classNames from 'classnames';

import { trackLink } from '../../../scripts/analytics';

import './Button.scss';

const Button = ({
    className,
    label,
    link,
    target,
    type,
    size,
    align,
    onClick,
    track = false,
}) => {
    const classnames = classNames('Button', className, {
            Button__primary: type === 'primary',
            Button__secondary: type === 'secondary',
            'Button--large': size === 'large',
            'Button--center': align === 'center',
        }),
        LinkElement = link && link.charAt(0) === '#' ? HashLink : Link;

    const clickBtn = () => {
        if (track) {
            trackLink(track, link);
        }
        if (onClick) {
            onClick();
        }
    };

    return (
        <LinkElement
            className={classnames}
            to={link}
            onClick={clickBtn}
            scroll={el => el.scrollIntoView({ behavior: 'smooth' })}
            target={target}
        >
            {label}
        </LinkElement>
    );
};

export default Button;
